import apiHttpClient from "./ApiHttpService";

export default class WorkSlipService {
  getWorkSlip(workDate) {
    return apiHttpClient.get(`trs/mobile/WorkSlip/getWorkSlip/${workDate}`);
  }
  getWorkSlipOptions(workDate) {
    return apiHttpClient.get(
      `trs/mobile/WorkSlip/getWorkSlipOptions/${workDate}`
    );
  }
  getAllWorkSlips() {
    return apiHttpClient.get(
      `trs/mobile/WorkSlip/getAllWorkSlips`
    );
  }
  isEmployeeResponsible(workSlipNumber) {
    return apiHttpClient.get(
      `trs/mobile/WorkSlip/isEmployeeResponsible/${workSlipNumber}`
    );
  }
  isEmployeeADriver(workDate) {
    return apiHttpClient.get(
      `trs/mobile/WorkSlip/isEmployeeADriver/${workDate}`
    );
  }
  changeEmployeeDriverStatus(isDriver, workDate) {
    return apiHttpClient.put(
      `trs/mobile/WorkSlip/changeEmployeeDriverStatus/${isDriver}/${workDate}`
    );
  }
  isEmployeeStayingOvernight(workDate) {
    return apiHttpClient.get(
      `trs/mobile/WorkSlip/isEmployeeStayingOvernight/${workDate}`
    );
  }
  changeEmployeeOvernightStatus(workDate, overnight) {
    return apiHttpClient.put(
      `trs/mobile/WorkSlip/changeEmployeeOvernightStatus/${workDate}/${overnight}`
    );
  }
  getAssignedBus(workDate) {
    return apiHttpClient.get(
      `trs/mobile/WorkSlip/getAssignedBus/${workDate}`
    );
  }
}
